import { Component, EventEmitter, Input, OnInit, Output, TemplateRef , ChangeDetectionStrategy } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { GmsconfirmComponent } from '../../dialogs/gmsconfirm/gmsconfirm.component';
import { UtilService } from '../../services/util/util.service';

@Component({
    selector: 'app-sortable-container',
    templateUrl: './sortable-container.component.html',
    styleUrls: ['./sortable-container.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SortableContainerComponent implements OnInit {

  @Input() configObj;
  @Input() itemsList;
  @Output() updateItemsList = new EventEmitter;
  private dragIndex: number = -1;
  public isSelectAll: boolean = false;
  private selectedItems = [];
  public shortcutKey: string = "";
  private emojiItem: any;

  constructor(private modalRef: NgbModal, private utilService: UtilService) { }

  ngOnInit(): void {
    let arrayLen = this.itemsList?.length;
    for (let i = 0; i < arrayLen; i++) {
      this.itemsList[i].is_selected = false;
      if (this.configObj?.is_editable) {
        this.itemsList[i].show_edit_icon = false;
      }
      if (this.configObj?.enable_preview) {
        this.itemsList[i].enable_preview = true;
      }
    }
  }

  onDragStart(event: DragEvent, index: number): void {
    this.dragIndex = index;
    event.dataTransfer?.setData('text/plain', this.itemsList[index]?.identifier);
    event.dataTransfer.effectAllowed = 'move';
  }

  onDragEnter(event) {
    let draggedEl: any = event.target;
    draggedEl.style.opacity = '0';
    draggedEl.style.transition = 'all 100ms ease';
  }

  onDragLeave(event) {
    let draggedEl: any = event.target;
    draggedEl.style.opacity = '1';
    draggedEl.style.transition = 'all 700ms ease';
  }

  // Handle the drag over event on an emoticon
  onDragOver(event: DragEvent): void {
    event.preventDefault();
    event.dataTransfer.dropEffect = 'move';
  }

  // Handle the drop event on an emoticon
  onDrop(event: DragEvent, index: number): void {
    event.preventDefault();
    const data = event.dataTransfer?.getData('text/plain');
    const emoticon = this.itemsList.find(e => e.identifier === data);
    this.itemsList.splice(this.dragIndex, 1);
    this.itemsList.splice(index, 0, emoticon);
    this.dragIndex = -1;

    let targetElement: any = event.target;
    targetElement.style.opacity = '1';
    targetElement.style.transition = 'all 700ms ease';
  }

  onItemSelect(event, index) {
    let result = event.target.checked;
    if (result) {
      this.selectedItems.push(this.itemsList[index]);
    } else {
      let selectedItemInd = this.selectedItems.findIndex(item => item[this.configObj.sortorder_key] == this.itemsList[index][this.configObj.sortorder_key]);
      if (selectedItemInd != -1) {
        this.selectedItems.splice(selectedItemInd, 1);
      }
    }

    this.isSelectAll = (this.itemsList.length == this.selectedItems.length);

    if (this.configObj?.is_editable) {
      if (this.selectedItems.length == 1) { // type is emojis
        let selectedItemInd = this.itemsList.findIndex(item => item[this.configObj.sortorder_key] === this.selectedItems[0][this.configObj.sortorder_key]);
        if (selectedItemInd !== -1) {
          this.itemsList[selectedItemInd].show_edit_icon = true;
        }
      } else {
        let arrayLen = this.itemsList?.length;
        for (let i = 0; i < arrayLen; i++) {
          this.itemsList[i].show_edit_icon = false;
        }
      }
    }
  }

  onSelectAll() {
    let arrayLen = this.itemsList.length;
    for (let i = 0; i < arrayLen; i++) {
      this.itemsList[i].is_selected = this.isSelectAll;
    }

    this.selectedItems = this.isSelectAll ? [...this.itemsList] : [];
  }

  onConfirmSortOrder() {
    let response = {
      "data": this.itemsList,
      "type": "sort",
      "emoticon_type": this.configObj.type
    }
    this.updateItemsList.emit(response);
  }

  onDelete() {
    if (this.selectedItems.length > 0) {
      let ngbModalOptions: NgbModalOptions = {
        backdrop: 'static',
        keyboard: false,
        // centered: true
      };
      const modalRef = this.modalRef.open(GmsconfirmComponent, ngbModalOptions);
      modalRef.componentInstance.configObj = {
        "title": 'Confirmation',
        "message": 'Are you sure you want to delete selected emoticon(s)?',
        "btnOkText": 'Ok',
        "btnCancelText": 'Cancel'
      };
      modalRef.componentInstance.confirmed.subscribe((response) => {
        if (response) {
          let data = {
            "data": this.selectedItems,
            "type": "delete",
            "emoticon_type": this.configObj.type
          }
          this.updateItemsList.emit(data);
          console.log("Clicked OKay");
        } else {
          console.log("Cancel and dismiss");
        }
      });
    } else {
      this.utilService.snackMsg("Please select emoiticon(s) to delete");
    }
  }

  showPreview(anim, index) {
    if (index != -1) {
      let id = 'animDiv' + index;
      setTimeout(() => {
        let previewEle = document.getElementById("anim-preview_" + index);
        previewEle.classList.remove("d-none");
        let ele = document.getElementById('emoticon_' + index);
        console.log(anim.effect_type, ele, id);
        let style = document.createElement('style');
        if (anim.effect_type == 'floating') {
          style.textContent = `
          @keyframes floater {
              0% {
                  transform: translate(0, 0px);
              }

              50% {
                  transform: translate(0, 15px);
              }

              100% {
                  transform: translate(0, 0px);
              }
          }
        `;
          ele.style.animation = 'floater 1.5s infinite';
        } else if (anim.effect_type == 'rolling') {
          style.textContent = `
          @keyframes rolling {
              0% {
                  opacity: 0;
                  transform: translateX(-100%) rotate(-120deg);
              }

              100% {
                  opacity: 1;
                  transform: translateX(0px) rotate(0deg);
              }
          }
          `;
          ele.style.animation = 'rolling 1.5s infinite';
        } else if (anim.effect_type == 'random_popup') {
          style.textContent = `
          @keyframes popout {
            from {
                transform: scale(0)
            }

            90% {
                transform: scale(1.1)
            }

            to {
                transform: scale(1)
            }
        }
          `;
          ele.style.animation = 'popout .2s ease';
        }
        document.head.appendChild(style);
        setTimeout(() => {
          ele.style.animation = null;
          previewEle.classList.add("d-none");
        }, 3000);
      }, 500);
    }
  }

  onItemEdit(content: TemplateRef<any>, item) {
    this.modalRef.open(content, { ariaLabelledBy: 'modal-basic-title', centered: true });
    this.shortcutKey = item.shortkey;
    this.emojiItem = item;
  }

  // Add Shortcut Key Methods => START

  validateShortcutKey(event) {
    let value = event.target.value;
    event.target.value = value.replace(' ', '');
    this.shortcutKey = event.target.value;
  }

  onUpdate() {
    let asciiSortkey = Array.from(new TextEncoder().encode(this.shortcutKey));
    let data = {
      "data": {
        "item": this.emojiItem,
        "asciiSortkey": asciiSortkey
      },
      "type": "update",
      "emoticon_type": this.configObj.type
    }
    this.updateItemsList.emit(data);

    let arrayLen = this.itemsList?.length;
    for (let i = 0; i < arrayLen; i++) {
      this.itemsList[i].is_selected = false;
      if (this.configObj?.is_editable) {
        this.itemsList[i].show_edit_icon = false;
      }
    }
    this.selectedItems = [];
    this.modalRef.dismissAll();
  }

  // Add Shortcut Key Methods => END

}
